import * as GraphQL from 'graphql/index.js';
window.graphql = GraphQL;
